import React, { useEffect } from 'react';
import { Route, Switch } from 'react-router';
import { connect } from "react-redux";
import PropTypes from "prop-types";
import NavMenu from './NavMenu';
import PageNotFound from '../PageNotFound';
import MyRoutesPage from '../routes/MyRoutesPage';
import ExplorePage from '../routes/ExplorePage';
import RouteKeywordSearchPage from '../routes/RouteKeywordSearchPage';
import UploadRoutePage from '../routes/UploadRoutePage';
import BookmarksPage from '../routes/BookmarksPage';
import EditRouteDetailsPage from '../routes/EditRouteDetailsPage';
import SettingsPage from '../user/SettingsPage';
import ProfilePage from '../user/profile/ProfilePage';
import ProfileUserPage from '../user/profile/ProfileUserPage';
import GroupPage from '../groups/GroupPage';
import GroupsPage from '../groups/GroupsPage';
import EventPage from '../events/EventPage';
import EventsPage from '../events/EventsPage';
import PostPage from '../postComments/PostPage'
import LoadingPage from "../common/LoadingPage";
import SettingsPasswordForm from '../user/SettingsPasswordForm';
import SettingsAvatarForm from '../user/SettingsAvatarForm';
import SettingsSiteForm from '../user/SettingsSiteForm';
import SettingsGeneralForm from '../user/SettingsGeneralForm';
import GeneralSettingsPage from '../user/settings/GeneralSettingsPage';
import SiteSettingsPage from '../user/settings/SiteSettingsPage';
import SecuritySettingsPage from '../user/settings/SecuritySettingsPage';
import DeleteProfilePage from '../user/settings/DeleteProfilePage';
import DashboardPage from '../administration/DashboardPage';
import ErrorsPage from '../administration/ErrorsPage';
import RoutesPage from '../administration/RoutesPage';
import GroupAdminPage from '../administration/GroupsPage';
import UsersPage from '../administration/UsersPage';
import GarminConnectSettingsPage from '../user/settings/GarminConnectSettingsPage';
import ReactGA from 'react-ga';

function InternalSideNavLayout(
    {
        user,
        history,
        ...props
    }
) {

    useEffect(() => {
       
    }, [user])

    const trackingId = "UA-15349860-1";

    ReactGA.initialize(trackingId);

    return (
            <React.Fragment>
                <div className="container-fluid h-100">
                    <nav className="col-md-3 ml-sm-auto col-xl-2 d-none d-md-block bg-light sidebar">
                        <div className="sidebar-sticky">
                            <NavMenu />
                        </div>
                    </nav>
                    <main role="main" className="h-100 col-md-9 ml-sm-auto col-xl-10">
                        <Switch>
                            <Route path='/routes/explore' component={ExplorePage} />
                            <Route path='/routes/search' component={RouteKeywordSearchPage} />
                            <Route path='/routes/upload' component={UploadRoutePage} />
                            <Route path='/routes/edit/:id' component={EditRouteDetailsPage} />
                            <Route path='/user/bookmarks' component={BookmarksPage} />
                            <Route path='/user/routes' component={MyRoutesPage} />
                            <Route path='/user/settings/general' component={GeneralSettingsPage} />
                            <Route path='/user/settings/site' component={SiteSettingsPage} />
                            <Route path='/user/settings/avatar' component={SettingsAvatarForm} />
                            <Route path='/user/settings/security' component={SecuritySettingsPage} />
                            <Route path='/user/settings/garmin' component={GarminConnectSettingsPage} />
                            <Route path='/user/settings/closeaccount' component={DeleteProfilePage} />
                            <Route path='/user/settings' component={GeneralSettingsPage} />
                            <Route path='/user/profile/:id' component={ProfileUserPage} />
                            <Route path='/user/profile' component={ProfilePage} />
                            <Route path='/groups/:id' component={GroupPage} />
                            <Route path='/groups' component={GroupsPage} />
                            <Route path='/events/:id' component={EventPage} />
                            <Route path='/events' component={EventsPage} />
                            <Route path='/posts/:id' component={PostPage} />
                            <Route path='/_adm/users' component={UsersPage} />
                            <Route path='/_adm/groups' component={GroupAdminPage} />
                            <Route path='/_adm/routes' component={RoutesPage} />
                            <Route path='/_adm/errors' component={ErrorsPage} />
                            <Route path='/_adm/dashboard' component={DashboardPage} />
                            <Route component={PageNotFound} />
                        </Switch>
                    </main>
                </div>
            </React.Fragment>
    );
}


InternalSideNavLayout.propTypes =
{
    user: PropTypes.object
}


function mapStateToProps(state) {
    return {
        user: state.user
    };
}

const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(InternalSideNavLayout);



// WEBPACK FOOTER //
// ./src/components/common/InternalSideNavLayout.js